<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_cardsetting_banner.jpg')" alt="出金口座の登録方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <div class="sup-cardsetting-tabs">
          <router-link class="sup-cardsetting-tab" to="/page/sup-cardsetting-bank">
            銀行口座の登録方法
          </router-link>
          <router-link class="sup-cardsetting-tab" to="/page/sup-cardsetting-ewallet">
            eウォレットアカウントの登録方法
          </router-link>
          <router-link class="sup-cardsetting-tab sup-cardsetting-tab--active" to="/page/sup-cardsetting-ewalletid">
            各決済サービスのユーザーIDの確認方法
          </router-link>
        </div>
        <h1 class="sup-page-title">
          各決済サービスのユーザーIDの確認方法
        </h1>
        <div class="sup-infobox">
          <p class="sup-infobox-title">
            ※Match Pay IDの確認方法※
          </p>
          <p class="sup-infobox-desc">
            Match Payへログイン後、左上のアイコンをタップし、<br>
            設定画面の上から2番目のアカウント名が「Match Pay ID」です。
          </p>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewalletid1.jpg')" alt="Match Pay ホーム画面">
          </div>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewalletid4.jpg')" alt="Match Pay 設定画面">
          </div>
        </div>
        <div class="sup-infobox">
          <p class="sup-infobox-title">
            ※VegaWalletの「Uから始まるユーザーID」の確認方法※
          </p>
          <p class="sup-infobox-desc">
            VegaWalletへログイン後、<br>
            ホーム画面に記載されるベガIDが、「Uから始まるユーザーID」です。
          </p>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewalleti2.jpg')" alt="VegaWallet ホーム画面">
          </div>
        </div>
        <div class="sup-infobox">
          <p class="sup-infobox-title">
            ※Jetonbankの「7桁数字のユーザーID」の確認方法※
          </p>
          <p class="sup-infobox-desc">
            Jetonbankへログイン後、右上の二本線アイコンから「アカウント管理」をタップし、<br>
            お名前の下部に記載される顧客IDが、「7桁数字のユーザーID」です。
          </p>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewalleti3.jpg')" alt="Jetonbank メニュー画面">
          </div>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewalletid5.jpg')" alt="Jetonbank アカウント管理画面">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
